<template>
    <div class="hpHotels reveal"> 

        <div class="hotelsTitle">
            <div class="split-text title section-title">
                <p>CONFERENCE MAP</p>
            </div>  
            <div class="split-text hotelsSubtitle fs14">
                Hotel room availability is limited and depends on the number of vacant rooms.
            </div>
        </div>

        <div class="hotelsList">                    
            <ul>
                <li v-for="(item,index) in hotels" :key="'hotel_'+index">
                    <div class="hNameWrapper">
                        <div class="hName" :style="'--index:'+index">
                            <!-- <i :style="'color:'+item.color" class="fal fa-location"></i> -->
                            <hotel-pin :pincolor="item.color"></hotel-pin>
                            <span class="hNameText fs14">{{item.name}}</span>
                        </div>
                    </div>
                    <div :style="'--index:'+index" class="hLine"></div>
                </li>
            </ul>
        </div>

        <div class="hotelsMap">
            <img class="mapImg" :src="'img/map/palma-map-dark.png'" />
            <span class="hPoint" 
                v-for="(pItem,index) in hotels" 
                :key="'pItem_'+index"
                :style="'--index:'+index+';top:'+pItem.mapY+'%;left:'+pItem.mapX+'%'">
                <!-- <i :style="'color:'+pItem.color" class="fal fa-location"></i> -->
                <hotel-pin :pincolor="pItem.color"></hotel-pin>
                <div :class="['pointText','fs14',pItem.pointTextCss]">
                    {{pItem.name}}
                </div>
            </span>
        </div>        
    </div>
</template>

<style>    
    .hpHotels
    {
      width: 100%;
      position: relative;
      min-height: 100vh;
      height: 100vh;
      background-color: #132c44;
    }
    .hotelsMap
    {
        position: absolute;
        top: 0px;
        left: 0px;        
    }

    .hpHotels.reveal .mapImg
    {
        opacity: 0;
        transition: all ease 0.8s;
        transition-delay: 0.5s;
        width: 100vw;
        height: auto;
    }
    .hpHotels.reveal.active .mapImg
    {
        opacity: 1;
    }


    .hotelsTitle
    {
        position: absolute;
        top: 90px;
        left: 0px;
        width: 100%;
        z-index: 1000;
    }


    .hotels-container{
        margin: auto;
        width: clamp(800px,70vw,1500px);
        text-align: center;
    }

    .hotelsCols
    {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-top: 5vw;

    }
    .hotelsList
    {
        flex: 40%;      
        display: none;  
    }
    .hotelsMap
    {
        flex: 60%;        
    }
    .hmapContainer
    {
        clear: both;
        position: relative;
        /* border: solid 1px red; */
    }
    .hmapPoints
    {
        position: absolute;top: 0px;left: 0px;        
    }
        .hmapInner
        {
            position: relative;top: 0px;left: 0px;        
        }
            .hPoint{
                position: absolute;
                z-index: 1000;
                opacity: 0;
                transform: translate(-50%, -100%);
                transition: all ease-in-out 0.8s;
                transition-delay: calc(0.5s + (0.2s * var(--index))) !important;
            }
            .hPoint .pin
            {
                transform: scale(1.8);
                transform-origin: bottom center;                
            }
            .hPoint .pointText
            {
                position: absolute;
                top: 30px;
                left: -50%;
                color: #fff;
                width: 120px;
            }
            .hPoint .pointText.right
            {
                top: -5px;
                left: 140%;            
            }

    .hpHotels.reveal.active .hPoint
    {
        transform: translate(-50%, -100%);
        opacity: 1;
    }

    

    .hotelsList ul
    {
        list-style: none;
    }
    .hotelsList ul li
    {
        text-align: left;
    }

    .hNameWrapper
    {
        overflow: hidden;
    }
    .hName
    {
        opacity: 0;
        padding: 12px 0px;
        display: flex;
        align-content: center;
    }
    .hpHotels.reveal.active .hName
    {
        animation-delay: calc(0.2s + (0.2s * var(--index))) !important;
        animation: hpnameUp 1.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
    }
    @keyframes hpnameUp {
        from {transform: translateY(33px);opacity: 0;}  
        to {transform: translateY(0);opacity: 1;}
    }




    .hName .hNameText
    {
        padding-left: 8px;
        position: relative;
        top: 3px;
        color:#fff;
    }
    .hLine
    {
        clear: both;
        border-bottom: solid 1px #fff;
        height: 2px;        
        opacity: 0.2;
        width: 0px;
        transition: all ease-in-out 1.4s;
        transition-delay: calc(0.2s + (0.25s * var(--index))) !important;
    }
    .hotelsList ul li:last-child .hLine
    {
        display: none;
    }
    .hpHotels.reveal.active .hLine
    {
        width: 300px;
    }



    .hotelsMap .mapImg
    {
        width: 100%;
        height: auto;
        opacity: 0;
        transition: all ease 0.8s;
        transition-delay: 0.6s;
    }
    .hpHotels.reveal.active .mapImg
    {
        opacity: 0.8;
    }


    .hpHotels .split-text
    {
        color: #fff;
    }

  .hpHotels .split-text.subtitle .xLine .xLineText
  {
    font-weight: 300 !important;
  }
  .hpHotels .split-text.hotelsSubtitle,
  .hpHotels .split-text.title
  {
    text-align: center;
  }
  .hpHotels .split-text.title .xLine .xLineText
  {
    font-weight: 200 !important;
    text-align: center;
  }


  .googleMapsIcon
  {
    width: 16px;
    height: auto;
    margin-right: 10px;
  }






@media all and (max-device-width: 1024px)
{  
    .hotelsCols
    {
        display: block;
    }
    .hotelsList
    {
        padding-bottom: 50px;
    }
    .hotelsList ul {
        margin: auto;
        width: 40%;
    } 
    .btnGoogle
    {
        position: relative;
        top: -80px;
    }   
}

  @media (max-width: 850px) { 
    .hotelsTitle
    {
        position: initial;
        padding-top: 50px;
        width: 80vw;
        margin: auto;
        text-align: center;    
    }
    .hotelsSubtitle    
    {
        padding-top: 15px;
    }

    .hotelsMap
    {
        position: relative;
    }
    .pointText
    {
        display: none;
    }
    .hotels-container
    {
        width: 80vw;
    }
    .hotelsList
    {
        width: 80vw;
        margin: auto;
        padding-top: 40px;  
        display: block; 
    }
    .hotelsList ul
    {
        padding: 0px;
        width: 100%;
    }
    .hmapContainer
    {
        transform: scale(1.5);
        transform-origin: top;        
    }
    .btnGoogle
    {
        position: relative;
        top: 30px;
    }   
    .hpHotels
    {
        min-height: 1px;
        padding-bottom: 0px;
        height: auto;
    }
    .hPoint .pin
    {
        transform: scale(1.2);
    }
  }


  /* LARGE SCREENS */
    @media (min-width: 2000px) 
    {
        .hPoint .pin
        {
            transform: scale(2.5);
        }
        .hPoint .pointText {
            width: 180px;
        }


        
    }
</style>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";
import site_data from "@/site_data.json"

import HotelPin from "@/views/hp/hpHotelPin.vue";

export default {
  name: "hpHotels",
  components:{HotelPin},
  data()
  {
    return {
      hotels:site_data[1].HOTELS
    }
  },
  mounted()
  {

  },
  methods:
  {
    getItemData(item)
    {

    }
  }
};
</script>
